<template>
  <div class="page-dialog">
    <el-form
      label-width="90px"
      label-position="right"
      :inline="true"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="终端名称">
            <el-input v-model="conditions.storeName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tr">
        <el-button type="default" size="small" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="small" :loading="loading" icon="el-icon-search" @click="queryData(1)">查询</el-button>
      </el-row>
    </el-form>
    <div class="table-container">
      <TableCommon
        :custome-config="() => vxeShowCustom('gridOptions')"
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          empty-text="暂时没数据"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { queryDirectStore } from '@/api/applyForGoods/index'

// 接口入口
export default {
  props: {
    info: {
      type: Object,
      default: () => null
    },
    mode: {
      type: String,
      default: ''
    },
    terminalQureyParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      pageOption: {
        current: 1,
        size: 50
      },
      totalCount: 0,
      selectDataOptions: {},
      conditions: {
        storeName: '',
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'radio', title: '', filed: 'radio', width: 50 },
          { field: 'storeId', title: '终端ID' },
          { field: 'storeName', title: '终端名称' },
          { field: 'consignee', title: '联系人',},
          { field: 'consigneePhone', title: '联系电话' },
          { field: 'provinceName', title: '省' },
          { field: 'cityName', title: '市' },
          { field: 'districtName', title: '区' },
          { field: 'address', title: '收货地址' },
        ],
        data: []
      }
    }
  },
  mounted() {
    this.queryData()
  },
  computed: {
    pagination(){
      return{
        page: this.pageOption.current,
        pagesize: this.pageOption.size,
        totalCount: this.totalCount,
      }
    }
  },
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询
    async queryData(page) {
      page && (this.pageOption.current = page)
      const params = { page:this.pageOption, ...this.terminalQureyParams, ...this.conditions }
      this.loading = true
      const res = await queryDirectStore(params)
      this.gridOptions.data = res.data.data.records
      this.totalCount = res.data.data.total
      this.loading = false
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pageOption = {
        current: pageParams.page,
        size: pageParams.pagesize
       }
      this.queryData()
    },
    resetQuery() {
      this.conditions = {
        storeName: '',
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        const selectData = this.$refs.gridOptions.getRadioRecord()
        resolve(selectData)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/terminalAddress.vue